import { MascotEmpty } from '../components/Watermark';
import { openTelegramLink } from '../telegram';

const DEFAULT_MESSAGE =
  'Доступ к приложению ограничен. Если считаете это ошибкой — напишите нам.';

/** Полноэкранная заглушка для забаненного игрока (403 { banned: true }). */
export function BannedScreen({ message }: { message?: string | null }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '32px 24px',
        gap: 16,
      }}
    >
      <MascotEmpty />
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 800, margin: 0 }}>
        Доступ ограничен
      </h1>
      <p style={{ fontSize: 13, color: 'var(--text-3)', maxWidth: 360, margin: 0 }}>
        {message?.trim() || DEFAULT_MESSAGE}
      </p>
      <button
        className="btn"
        onClick={() => openTelegramLink('https://telegram.me/ante_assistant')}
      >
        💬 Написать @ante_assistant
      </button>
      <button className="btn btn--ghost" onClick={() => window.location.reload()}>
        Обновить
      </button>
    </div>
  );
}
